import ApiEndpointConstants from '../constants/api/ApiEndpointConstants';
import api from './API';

export const uploadImg = (params) => {
    const {snCode, img} = params;
    return api.post(
        `${ApiEndpointConstants.UPLOAD}`,
        { snCode, file: img },
    );
}